import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"

import "./index.less"
import { Checkbox, Popover, Select } from "antd"
import {
  isAmbassadorActive,
  LOCAL_ACTIVE_ROL,
  LOCAL_ISOLATED_METRICS,
} from "../../utils/storage"
import { Link } from "react-router-dom"
import { QuestionCircleFilled } from "@ant-design/icons"
import SelectHR from "../Select"
import { get, isNaN } from "lodash"
import { ROLE_LEADER, TYPE_SURVEY,ROLE_AMBASSADOR } from "../../utils/constants"
import { loadTexts, sanitize } from "../../utils/i18n"

const { Option } = Select

export function HeaderDimension(props) {
  const intlHeader = loadTexts("reports_dimensions_view").headerDimension
  const { measureInfo, searchLocation } = props
  const [isAmbassadorRole] = useState(isAmbassadorActive())
  const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()

  const renderFilters = () => {
    const {
      selectedDivisionInfo,
      checkboxExclude,
      changeDivision,
      changeExcludeCheckbox,
      measureInfo,
      searchLocation,
      divisionsTotal,
      selectedDivision,
      divisions,
    } = props
    if (
      isNaN(parseInt(searchLocation.id_segment)) &&
      get(measureInfo, "segments", []).length > 0
    ) {
      return null
    }

    return (
      <Fragment>
        {selectedDivisionInfo && LOCAL_ISOLATED_METRICS() == "true" && (
          <div
            style={{
              marginLeft: "auto",
              paddingRight: 10,
              height: 30,
              paddingTop: 5,
            }}>
            <Checkbox
              checked={checkboxExclude}
              onChange={(e) => changeExcludeCheckbox(e)}>
              {intlHeader.excludeSubDivisions}
            </Checkbox>
            <Popover
              placement="top"
              content={
                <div style={{ maxWidth: 245, textAlign: "center" }}>
                  {sanitize(intlHeader.tooltipExclude)}
                </div>
              }>
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 8,
                }}
              />
            </Popover>
          </div>
        )}
        <div>
          <div>
            <SelectHR
              allowClear={!isAmbassadorRole}
              value={selectedDivision || undefined}
              options={divisions}
              placeholder={intlHeader.placeholderSelectDivision}
              style={{ width: 200 }}
              label="name"
              labelKey="id_division"
              onChange={(event) =>
                changeDivision(event ? parseInt(event.id_division) : null)
              }
            />
          </div>
          <div
            style={{
              color: "#979797",
              fontSize: "13px",
              marginTop: "8px",
              textAlign: "end",
            }}>
            {`${selectedDivisionInfo ? selectedDivisionInfo.employees : divisionsTotal?.employees} ${intlHeader.collaborators}`}
          </div>
        </div>
      </Fragment>
    )
  }

  const renderFiltersLeadership = () => {
    const {
      changeDivision,
      selectedDivisionInfo,
      leaders,
    } = props


    // remueve al lider actual de la lista de lideres
    let finalLeaders = leaders.filter((e) => !e.current_leader)

    if (finalLeaders.length != 0) {
        return (
            <Select
            placeholder={
                isUserLeader ? intlHeader.selectLeader : intlHeader.resultByTeam
            }
            showSearch
            optionFilterProp="search"
            allowClear
            style={{ width: 200 }}
            value={selectedDivisionInfo ? selectedDivisionInfo.id : undefined}
            onChange={(event) =>
                changeDivision(event ? parseInt(event) : null)
            }>
            {finalLeaders
                .map((item, i) => (
                <Option
                    idOption={item.id}
                    search={item.name}
                    key={i}
                    value={item.id}>
                    {item.name}
                </Option>
                ))}
            </Select>
        )
    }
    return null
  }

  const returnTo = () => {
    const { back } = searchLocation
    const {
      selectedDivision
    } = props
    const isAmbassador = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
    const division=isAmbassador? `?f&id_division=${selectedDivision}` :''
    return back === "divisions"
      ? `/reports/measure/${measureInfo.id_measure}/divisions`
      : `/reports/measure/${measureInfo.id_survey_type}/${measureInfo.id_measure}${division}`
  }

  const nameReturnTo = () => {
    const { back } = searchLocation
    return back === "divisions"
      ? `< Resultado por división`
      : `< ${measureInfo.name}`
  }

  return (
    <div className="HeaderDimension">
      <div className="HeaderDimension-Link">
        <Link to={returnTo()}>{nameReturnTo()}</Link>
      </div>
      <div className="HeaderDimension-Container">
        <div className="HeaderDimension-Container-Title">
          {!props.selectedDivisionInfo ? (
            intlHeader.titleAnalysis
          ) : (
            <Fragment>
              {`${intlHeader.title} `}
              <span style={{ fontWeight: 400 }}>
                {props.selectedDivisionInfo.name}
              </span>
            </Fragment>
          )}{" "}
          {parseInt(searchLocation.id_segment) !== 0 &&
            !isNaN(parseInt(searchLocation.id_segment)) &&
            `- ${get(measureInfo, "segment_name", "")}`}
        </div>
        <div className="HeaderDimension-Container-Filter">
          {(measureInfo.id_survey_type === TYPE_SURVEY.climate.idSurveyType ||
            measureInfo.id_survey_type !==
              TYPE_SURVEY.leadership.idSurveyType) &&
            renderFilters()}
          {measureInfo.id_survey_type === TYPE_SURVEY.leadership.idSurveyType &&
            renderFiltersLeadership()}
        </div>
      </div>
    </div>
  )
}

HeaderDimension.propTypes = {
  selectedDivisionInfo: PropTypes.object,
  checkboxExclude: PropTypes.bool,
  measureInfo: PropTypes.object,
  changeDivision: PropTypes.func,
  changeExcludeCheckbox: PropTypes.func,
  searchLocation: PropTypes.object,
}

export default HeaderDimension
